
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class OxyDisplayValue extends Vue {
  @Prop()
  isInheriting!: boolean;

  @Prop()
  isOverwritten!: boolean;

  @Prop()
  isVariable!: boolean;

  @Prop()
  isFilled!: boolean;

  @Prop({ default: true })
  applyFillClass!: boolean;
}
